// const baseUrlPro = 'https://api.yngxccwl.com'//共仓物流正式
// const baseUrlDev = 'https://dev.ynjgyy.cn'//测试
// const baseUrlPro = 'https://www.ynjgyy.cn'//正式
// const baseUrlDev = 'https://dev.ynjgyy.cn'//测试
export const isDev = false // 是否是开发模式
export const baseUrl = isDev ? 'https://dev.ynjgyy.cn' : 'https://www.ynjgyy.cn'
export const shopUrl = "https://testmall.ynjgyy.cn"
export const signUrl = "https://eam.ynjgyy.cn/api/"
// 共仓物流
// export const appId: string = 'GCWL1000618880'
// export const appTitle = '共仓物流'
// export const homeRoute = '/home';
// export const menuText = {
//     'partyTitle': '物流',
//     'partyMenu1': '物流',
//     'partyMenu2': '物流',
//     'partyMenu3': '物流',
//     'roleName': '物流',
//     'postNotice': '防疫报备协议',
// }
// export const serviceConfig: any[] = [

// ]

//视频产业园
// export const appId: string = 'RSSY1000618910'
// export const appTitle = '共享仓超数字视频产业园'
// export const homeRoute = '/home';
// export const menuText = {
//     'partyTitle': '视频产业园',
//     'partyMenu1': '视频产业园',
//     'partyMenu2': '视频产业园',
//     'partyMenu3': '视频产业园',
//     'roleName': '视频产业园',
// }

// export const appId: string = 'GCWL1000618880'
// export const appTitle = '共仓物流'
// export const homeRoute = '/home';
// export const menuText = {
//     'partyTitle': '物流',
//     'partyMenu1': '物流',
//     'partyMenu2': '物流',
//     'partyMenu3': '物流',
//     'roleName': '物流',
// }
// export const appId: string = 'GCWL1000618880'
// export const appTitle = '共仓物流'
// export const baseUrl = apiUrl
// export const baseUrl = apiUrl
// export const homeRoute = '/home';
// export const menuText = {
//     'partyTitle': '物流',
//     'partyMenu1': '物流',
//     'partyMenu2': '物流',
//     'partyMenu3': '物流',
//     'roleName': '物流',
// }
// export const serviceConfig = [
//     {name: '用户协议', id: 'courier_service'},
//     {name: '司机福利', id: 'courier_welfare'},
//     {name: '隐私政策', id: 'courier_privacy'},
//     {name: '入驻协议', id: 'courier_settled'},
// ]

// 共享英才云
export const appId: string = 'GXYC1000618830'//GXYC
export const appTitle = '共享英才云'
export const homeRoute = '/personnelIndex'
export const menuText = {
    'partyTitle': '空',
    'partyMenu1': '空',
    'partyMenu2': '空',
    'partyMenu3': '空',
    'roleName': '空',
}
export const serviceConfig: any[] = [
    {name: '用户协议', id: 'talent_service'},
    {name: '隐私政策', id: 'talent_privacy'},
    {name: '会员协议', id: 'talent_vip_service'},
    {name: '英才币使用规则', id: 'talent_coin_rule'},
    {name: '电子签约协议', id: 'talent_contracting_service'},
    {name: '代运营协议', id: 'talent_operation_service'},
]



// 建供易营
// export const appId: string = 'JGYY1000618810'
// export const appTitle = '建供易营'
// export const homeRoute = '/index/dashboard';
// export const menuText = {}
// export const serviceConfig:any[] = []





// 共享仓超独立
// export const appId: string = 'GXCC1000618890'// gxccdladmin
// export const appTitle = '共享仓超独立'
// export const homeRoute = '/index/dashboard'
// export const menuText = {
//     'partyTitle': '空',
//     'partyMenu1': '空',
//     'partyMenu2': '空',
//     'partyMenu3': '空',
//     'roleName': '空',
// }
// export const serviceConfig = [
//     {name: '用户协议', id: 'gxcc_user'},
//     {name: '隐私政策', id: 'gxcc_privacy'},
// ]


// 共享仓超综合
// export const appId: string = 'GXCC1000618800'
// export const appTitle = '共享仓超综合'
// export const homeRoute = '/personnelIndex';
// export const menuText = {
//     'partyTitle': '空',
//     'partyMenu1': '空',
//     'partyMenu2': '空',
//     'partyMenu3': '空',
//     'roleName': '空',
// }
// export const serviceConfig:any[] = []


// 商家后台
// export const appId: string = '1000618811'
// export const appTitle = '商家'
// export const homeRoute = '/personnelIndex';
// export const menuText = {
//     'partyTitle': '空',
//     'partyMenu1': '空',
//     'partyMenu2': '空',
//     'partyMenu3': '空',
//     'roleName': '空',
// }
// export const serviceConfig:any[] = []


// 数视园RSSY1000618910
// export const appId: string = 'RSSY1000618910'
// export const appTitle = '共享仓超数字视频产业园'
// export const homeRoute = '/personnelIndex';
// export const menuText = {
//     'partyTitle': '数视园',
//     'partyMenu1': '数视园',
//     'partyMenu2': '数视园',
//     'partyMenu3': '数视园',
//     'roleName': '数视园',
// }
// export const serviceConfig = [
//     {name: '隐私政策', id: 'rssy_privacy'},
//     {name: '用户协议', id: 'rssy_user'},
//     {name: '入驻协议', id: 'rssy_settled'}
// ]
